import { useForm } from '@mantine/form';
import { useState } from 'react';
import { validatePassword } from '../../../util/validation/commonValidation';

export interface ResetPasswordDto {
	id: string;
	password: string;
	checkPassword: string;
}

const defaultResetPassword: ResetPasswordDto = {
	id: '',
	password: '',
	checkPassword: '',
};

export function useResetPasswordForm(accountId = '0') {
	const [inputs, setInputs] = useState<ResetPasswordDto>({
		...defaultResetPassword,
		id: accountId, // Ensure accountId is set from defaultResetPassword
	});

	const form = useForm<ResetPasswordDto>({
		mode: 'uncontrolled',
		initialValues: inputs,
		validate: {
			password: (value) => validatePassword(value, false),
			checkPassword: (value, values) => {
				// biome-ignore lint/suspicious/noDoubleEquals: <explanation>
				if (value != values.password) {
					return 'Passwords do not match';
				}
			},
		},
		onValuesChange: (v) => {
			setInputs(v);
		},
	});

	return { form, inputs };
}
